export default {"src":"/_next/static/media/illustration.dc3d121c.svg","height":105,"width":92};